export enum FeeType {
  range = 'range',
  percent = 'percent',
  amount = 'amount',
}
